module.exports = __webpack_public_path__ + "img/bound-icon.eb41c9b2.svg";